import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {setUpdateButtonActiveStepToFalse,setUpdateButtonActiveStepToTrue} from '../../../../store/actions/main';
import {updateDirectionPforte, updateStepsPforte} from '../../../../store/actions/pforten';
import {InputRadio} from '../../../../module/inputRadio';


const Step_6 = (props) => {
  let [direction, selectDirection] = useState('');

    useEffect(() => {
      updateItems();
    })

   const updateItems = () => {
      const {direction} = props.data;

      selectDirection(direction);

      //update steps
      props.updateSteps(5);
      if (direction) props.updateSteps(6);

      if(direction || props.data.allVisitedSteps) {
        props.setUpdateButtonActiveStepToFalse();
      } else {
        props.setUpdateButtonActiveStepToTrue();
      }


   }

   const updateDirection = ev => {
      props.updateDirection(ev.target.value);
      updateItems();
   }

   const arrayRadioItems = [
     {labalValue: 'Nach Innen', labelTitel: 'Nach Innen'},
     {labalValue: 'Nach Außen', labelTitel: 'Nach Außen'}
   ]

   return (
           <div className="step_wrapper">
             <h2 className="step_header">Wie soll die Pforte geöffnet werden?</h2>
              <div className="step_icon_wrapper">
                  <div className="inner_textfield_wrapper direction">
                    <InputRadio
                      name='öffnungsrichtung'
                      aria-label='öffnungsrichtung'
                      onChange={updateDirection}
                      value={direction}
                      arrayRadioItems={arrayRadioItems}
                    />
                  </div>
              </div>
          </div>
   )
}

const mapStateToProps = state => {
    return {
      data: state.pfortenReducer.data
    }
}

const mapDispatchToProps = dispatch =>  {
   return {
      setUpdateButtonActiveStepToTrue: () => dispatch(setUpdateButtonActiveStepToTrue()),
      setUpdateButtonActiveStepToFalse: () => dispatch(setUpdateButtonActiveStepToFalse()),
      updateDirection: ev => dispatch(updateDirectionPforte(ev)),
      updateSteps: ev => dispatch(updateStepsPforte(ev))
   }
}


export default connect(mapStateToProps, mapDispatchToProps)(Step_6);
